// extracted by mini-css-extract-plugin
export default {"wrapper":"mainPage_wrapper__qWCfc","userContainer":"mainPage_userContainer__7rycV","title":"mainPage_title__lw4fP","card":"mainPage_card__06kGg","userImg":"mainPage_userImg__7BDg6"};